<template>
  <div class="nuttrema-list-item-custom" v-if="group.items.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ group.title }}</span>
    </div>

    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.added_by.style" :label="columns.added_by.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>

        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group.items" :id="`nuttrema-table-row-${item.id}`">

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text is-link" @click="gotoDetailsPage(item.id)" :title="$t('label.view_detail')">
                <div class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="two-line-text__origin">
                  <span>
                    <nuttrema-created-updated :item="item"></nuttrema-created-updated>
                    <!-- <span>{{ item.description }}</span> -->
                  </span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :label="columns.added_by.label" :style-props="columns.added_by.style">
              <span v-if="item.added_by_me">{{ $t('label.added_by_me') }}</span>
              <professional-info-small-card
                 v-else
                 class="is-in-section"
                 style="padding: 0"
                :reactive="false"
                :personDetails="_get(item, 'Owner')">
              </professional-info-small-card>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                class="el-button el-button--text"
                :to="{ name: _get(meta, 'navigation.edit'), params: { id: item.id } }">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right el-icon-right"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
    <!-- end ~ nuttrema-list-item__table -->

  </div>
  <!-- end ~ nuttrema-list-item-custom -->
</template>

<script>
import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';
import NuttremaCreatedUpdated from 'components/ui/label/nuttrema-created-updated';

import ProfessionalInfoSmallCard from 'components/ui/card/professional-info-small-card';

export default {
  name: 'allergens-index-list-item',
  mixins: [NuttremaIndexListItem],
  props: {
    group: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaCreatedUpdated,
    ProfessionalInfoSmallCard,
  },
  data() {
    return {
      columns: {
        name: {
          label: 'label.name',
          style: {
            'min-width': '300px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        added_by: {
          label: 'label.added_by',
          style: {
            'max-width': '310px',
            'min-width': '310px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/workspace/allergens/list/cmpt-allergens-index-list-item.vue